import { roles } from 'utils/access-rules/constants';

// Header role badge configuration. Each known role maps to:
//  - localizeId: an EXISTING, backend-translated Localize id (reused from the
//    questionnaire roles), so no new translations are required.
//  - colorKey / bgKey: theme tokens for the badge text/border and background.
export const roleBadges = {
  [roles.Applicant]: {
    localizeId: 'student', colorKey: 'roleApplicant', bgKey: 'roleApplicantBg',
  },
  [roles.Teacher]: {
    localizeId: 'teacher', colorKey: 'roleTeacher', bgKey: 'roleTeacherBg',
  },
  [roles.CompanyEmployee]: {
    localizeId: 'company', colorKey: 'roleCompany', bgKey: 'roleCompanyBg',
  },
  [roles.EducationProvider]: {
    localizeId: 'education-companion', colorKey: 'roleProvider', bgKey: 'roleProviderBg',
  },
};

// Returns the badge config for a known role, or null for missing/unknown roles
// (e.g. the backend-only SCHOOL_ADMINISTRATOR, which has no React UI) so the
// header hides the badge instead of crashing.
export const getRoleBadge = (role) => roleBadges[role] || null;
